import { combineReducers } from 'redux';
import AccountCreationReducer from '../sections/auth/accountCreation/AccountCreationReducer';
import AccountReducer from '../sections/auth/accountSettings/AccountReducer';
import LoginReducer from '../sections/auth/login/LoginReducer';
import SignupReducer from '../sections/auth/signup/SignupReducer';
import { RESET_REDUX, EMPTY_STORE_STATE } from './ActionTypes';

const appReducer = combineReducers({
  registrationAccount: AccountCreationReducer,
  registration: SignupReducer,
  login: LoginReducer,
  account: AccountReducer,
});

const rootReducer = (state, action) => {
  if (action.type === EMPTY_STORE_STATE) {
    state = {};
  }
  if (action.type === RESET_REDUX) {
    if (action.payload.reducerKey && action.payload.key) {
      const { reducerKey, key, value } = action.payload;
      state = {
        ...state,
        [reducerKey]: { ...state[reducerKey], [key]: value },
      };
    }
  }
  return appReducer(state, action);
};

export default rootReducer;
